import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { IMarketPrice, IMarketPriceState } from './interface';
import { ERequestStatus } from 'src/api/enumRequest';

const marketPriceState = (state: any) => state.marketPrice;

export const selectMarketPrice: (state: any) => IMarketPrice | null = createDraftSafeSelector(
  marketPriceState,
  (state: IMarketPriceState) => state.getMarketPrice.marketPrice
);

export const selectStatusGetMarketPrice: (state: any) => ERequestStatus = createDraftSafeSelector(
  marketPriceState,
  (state: IMarketPriceState) => state.getMarketPrice.status
);

export const selectErrorGetMarketPrice: (state: any) => string = createDraftSafeSelector(
  marketPriceState,
  (state: IMarketPriceState) => state.getMarketPrice.error
);
